import React from 'react';
import { Box, styled } from '@mui/material';

const StyledBoxItem = styled(Box)(() => ({
    flex: 1,
}));

export const QuotationFormItemWrapper: React.FC<{
    children?: React.ReactNode;
}> = (props) => {
    return <StyledBoxItem>{props?.children}</StyledBoxItem>;
};
